import { render } from "./Interactivemessages.vue?vue&type=template&id=6172b2fc"
import script from "./Interactivemessages.vue?vue&type=script&lang=js"
export * from "./Interactivemessages.vue?vue&type=script&lang=js"

import "./Interactivemessages.vue?vue&type=style&index=0&id=6172b2fc&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__